export const CancellationData = [
  {
    title: "Cancellation by User:",
    body: [
      {
        subTitle: "Standard Cancellation:",
        content: [
          "Users can cancel a booking without any penality up to [X] minutes/hours before the scheduled pickup time.",
          "If a user cancels a booking within [X] minutes/hours of the scheduled pickup time, a cancellation fee of [amount or percentage] will be charged.",
        ],
      },
      {
        subTitle: "No-Show:",
        content: [
          'If a user fails to show up at the designated pickup location without prior notice,it will be considered a "no-show".',
          "In the case of a no-show, the full fare for the ride, including any applicable waiting time charges, will be charged.",
        ],
      },
      {
        subTitle: "Repeat Offenders:",
        content: [
          "Users who frequently cancel or are frequently marked as no-shows may be subject to additional penalities, such as temporary suspension or limited access to certain features.",
        ],
      },
    ],
  },
  {
    title: "Cancellation by Driver:",
    body: [
      {
        subTitle: "Driver Cancellation:",
        content: [
          "In the event that a driver cancels a ride after accepting or booking, the user will not be charged any cancellation fees.",
          "The user will be promptly notified of the cancellation and the reasons, if available.",
          `The system will make efforts to assign an alternate driver to the user's booking.`,
        ],
      },
    ],
  },
  {
    title: "Cancellation Fee and Refunds:",
    body: [
      {
        subTitle: "Cancellation Fee:",
        content: [
          `The Cancellation fee will be deducted from the user's payment method associated with the booking.`,
          `The specific amounr or percentage of the cancellation fee will be clearly communicated to the user at the time of booking confirmation`,
        ],
      },
      {
        subTitle: "Refunds:",
        content: [
          `If a cancellation fee is charged, the user will not be eligible for a refund of the cancellation fee.`,
          `Refunds, if applicable,will be governed by the Company's refund policy.`,
        ],
      },
      {
        subTitle: "Amendments to the Cancellation Policy:",
        content: [
          `The Company reserves the right to modify or amend the cancellation policy at any time.Users will be notified of any changes through the App or other communication channels.`,
        ],
      },
    ],
  },
];
